module.exports = __webpack_public_path__ + "img/pet-passport_B09T61TL5N.32546793.jpg";